import { Button, Typography } from "@mui/material";
import ColumnContainer from "../../common/ColumnContainer";
import RowContainer from "../../common/RowContainer";
import { FormattedMessage } from "react-intl";

const ChangePasswordThankYou = ({ handleClose }) => {
  return (
    <ColumnContainer padding={"30px"} style={{ gap: "60px" }}>
      <ColumnContainer>
        <Typography variant="h6" color="var(--text-primary)">
          <FormattedMessage id="register.form.success" />
        </Typography>
        <Typography variant="p" color="var(--text-primary)">
          <FormattedMessage id="login.proceed" />
        </Typography>
      </ColumnContainer>
      <RowContainer center halfGap>
        <Button
          style={{ minWidth: "160px" }}
          variant="contained"
          color="primary"
          onClick={handleClose}
        >
          Ok
        </Button>
      </RowContainer>
    </ColumnContainer>
  );
};

export default ChangePasswordThankYou;
